import doc                 from '@widesk-core/decorators/doc';
import AccountServiceModel from '@/models/AccountServiceModel';
import { computed }        from 'mobx';
import { jwtDecode }       from 'jwt-decode';
import dayjs               from 'dayjs';

@doc.path('/users/{id}/mercure')
export default class UserTokenModel extends AccountServiceModel {
	@computed
	public get jwt(): string {
		return this.get('token', '');
	}

	@computed
	public get data(): Record<string, unknown> {
		return this.jwt ? jwtDecode(this.jwt) : {};
	}

	@computed
	public get exp(): number {
		return (this.data?.exp as number) * 1000 || 0;
	}

	@computed
	public get expMoment(): Dayjs {
		return dayjs(this.exp);
	}

	@computed
	public get isExpired(): boolean {
		return (this.exp || 0) < Math.ceil(new Date().valueOf() / 1000);
	}

	public get token(): string {
		return this.get('token', '');
	}
}
